export const ContactData = [
  {
    id: 1,
    text: "info@bharatclouds.com",
  },
  {
    id: 2,
    text: "+91 93447 72393 , 044 - 2364 4142",
  },
  {
    id: 3,
    text:
      "Module 308, Second Floor,  NSIC Software Technology Business Park,  Sector B-24, Guindy Industrial Estate,  Ekkattuthangal,Chennai, Tamilnadu - 600 032."
  },
];